import { render, staticRenderFns } from "./kvSvgIcon.vue?vue&type=template&id=6daaf507"
import script from "./kvSvgIcon.vue?vue&type=script&lang=js"
export * from "./kvSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./kvSvgIcon.vue?vue&type=style&index=0&id=6daaf507&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports